<template>
  <div class="uk-flex uk-flex-middle" uk-height-viewport>
    <div class="uk-width-2-3@m uk-width-1-2@s m-auto rounded">
      <div class="uk-child-width-1-2@m uk-grid-collapse login-card" uk-grid>
        <div class="uk-margin-auto-vertical uk-text-center uk-animation-scale-up p-5 uk-light">
          <template v-if="company">
            <img :src="company.logo_link" class="company-logo">
            <h3 class="mb-4">{{ company.name }}</h3>
            <p class="d-none">{{ company.type }}</p>
          </template>
        </div>
        <slot :company="company"></slot>
      </div>
      <BrandSignature
        :src="loginLogoFooter"
        class="d-flex mt-5"
        logo-width="120px"
        size="small"
        theme="muted"
        style="margin: 0 auto;"
      />
    </div>
  </div>
</template>
<script>
import { GET_ITEM_DETAIL_BY_ID as COMPANY_DETAIL, } from "@/core/services/store/REST.module";
import { DomainMapper } from "@/core/config/domain-mapper";
import {getAlias} from "@/utils/urlHelper";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";

export default {
  name: "AuthLayout",
  components: { BrandSignature },
  beforeCreate() {
      let self = this
      this.$store.dispatch(COMPANY_DETAIL, {
        url: 'api/company/info',
        filters: {
          alias: getAlias()
        }
      }).then((result) => {
        if (result.status) {
          const pureData = JSON.parse(JSON.stringify(result.data));
          if (Object.keys(pureData).length === 0) {
            this.$router.push({ path: "/404" });
          }

          self.company = result.data;
        } else {
          this.$router.push({ path: "/404" });
        }
      }).catch((error) => {
        this.$router.push({ path: "/404" });
      });
  },
  mounted() {
    let url = window.location.href
    if (url.includes('www.')) {
      this.company = {
        logo_link: '/media/images/anzera-logo-medium.png',
        name: 'Anzera Öğrenme Teknolojileri A.Ş.',
        type: 'Dijital Öğrenme Platformu',
        is_allowed_register_user: 0,
      }
    }
  },
  data() {
    return {
      company: {
        logo_link: '/media/images/anzera-logo-medium.png',
        name: 'Anzera Öğrenme Teknolojileri A.Ş.',
        type: 'Dijital Öğrenme Platformu',
        is_allowed_register_user: 0,
      },
    };
  },
  computed: {
    loginLogoFooter() {
      return process.env.BASE_URL + "media/images/logo-dark.svg";
    }
  },
}

</script>

<style scoped></style>
